import { useState } from "react";
import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im";

type Props = {
  name: string;
  label: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onChange: Function;
  className?: string;
}

export const CheckboxField = (props: Props) => {

  const [checked, setChecked] = useState(false);

  return (
    <div className={`relative h-20 w-full sm:w-full color flex flex-col p-3 rounded items-start ${props.className}`}
      onClick={() => {
        setChecked(!checked);
        props.onChange();
      }}
    >
      <p className="font-semibold w-full">{props.label}</p>
      <label htmlFor={props.name} className="block text-sm font-medium text-gray-600">
        {checked ? (
          <div className="flex gap-2 items-center justify-start text-greenPrimary">
            <ImCheckboxChecked />
            <span>Verificado</span>
          </div>
        ) : (
          <div className="flex gap-2 items-center justify-start text-redPrimary">
            <ImCheckboxUnchecked />
            <span>Não verificado</span>
          </div>
        )}
      </label>

    </div>
  );

}